
































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const smartMarketing = namespace('smartMarketing')

@Component
export default class CompanySettingsSmartMarketingContacts extends Vue {
    @smartMarketing.State readonly includeInternalContacts!: boolean
    @smartMarketing.State readonly includeExternalContacts!: boolean
    @smartMarketing.State readonly updatedFrom!: Date
    @smartMarketing.State readonly updatedUntil!: Date
    @smartMarketing.State readonly loadingContactsCount!: boolean
    @smartMarketing.State readonly contactsCount!: number
    @smartMarketing.Action readonly updateIncludeInternalContacts!: (includeInternalContacts: boolean) => Promise<void>
    @smartMarketing.Action readonly updateIncludeExternalContacts!: (includeExternalContacts: boolean) => Promise<void>
    @smartMarketing.Action readonly updateUpdatedFrom!: (updatedFrom: Date) => Promise<void>
    @smartMarketing.Action readonly updateUpdatedUntil!: (updatedUntil: Date) => Promise<void>

    get yesNoOptions(): Array<{ label: string, value: boolean }> {
        return [
            { label: this.$t('yes').toString(), value: true },
            { label: this.$t('no').toString(), value: false },
        ]
    }
}
